import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  getTransactions: "{getTransactions} actions",
  getFavPassengers: "[getFavPassengers] actions",
  getSupportItems: "[getSupportItems] actions",
  getSupportTickets: "[getSupportTickets] actions",
  getUserHistory: "[getUserHistory] actions",
  getUserCredit: "[getUserCredit] actions",
  mockedData: "[mockedData] action",
};

const initialProfileState = {
  transactions: undefined,
  favPassengers: undefined,
  supportItems: undefined,
  supportTickets: undefined,
  userHistory: undefined,
  userCredit: undefined,
  mockedData: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v7025-demo1-auth", whitelist: ["user", "profiles"] },
  (state = initialProfileState, action) => {
    switch (action.type) {
      case actionTypes.getTransactions: {
        const transactions = action.payload;
        return { ...state, transactions };
      }
      case actionTypes.getFavPassengers: {
        const favPassengers = action.payload;
        return { ...state, favPassengers };
      }
      case actionTypes.getUserCredit: {
        const userCredit = action.payload;
        return { ...state, userCredit };
      }
      case actionTypes.getSupportItems: {
        const supportItems = action.payload;
        return { ...state, supportItems };
      }
      case actionTypes.mockedData: {
        const mockedData = action.payload;
        return { ...state, mockedData };
      }
      case actionTypes.getSupportTickets: {
        const supportTickets = action.payload;
        return { ...state, supportTickets };
      }
      case actionTypes.getUserHistory: {
        const userHistory = action.payload;
        return { ...state, userHistory };
      }
      default:
        return state;
    }
  }
);

export const actions = {
  getAllTransactions: (payload) => ({
    type: actionTypes.getTransactions,
    payload,
  }),
  getUserCredit: (payload) => ({
    type: actionTypes.getUserCredit,
    payload,
  }),
  getAllFavPassengers: (payload) => ({
    type: actionTypes.getFavPassengers,
    payload,
  }),
  getAllSupportItems: (payload) => ({
    type: actionTypes.getSupportItems,
    payload,
  }),
  getAllSupportTickets: (payload) => ({
    type: actionTypes.getSupportTickets,
    payload,
  }),
  getUserHistory: (payload) => ({
    type: actionTypes.getUserHistory,
    payload,
  }),
  setMockedData: (payload) => ({ type: actionTypes.mockedData, payload }),
};
